import React from "react";

export default function BoardRectangleInspector({
  parameters,
  onChangeParameters,
  profile,
  onChangeProfile,
}) {
  const params = parameters || {};
  const p = profile || {
    type: "rect",
    width_expr: "width",
    height_expr: "height",
  };

  function patchParam(key, value) {
    onChangeParameters?.({
      ...params,
      [key]: Number(value) || 0,
    });
  }

  function patchProfile(key, value) {
    onChangeProfile?.({
      ...p,
      [key]: value,
    });
  }

  return (
    <div className="p-3 space-y-4">
      <h3 className="font-semibold text-lg">Board Rectangle</h3>

      <div>
        <label className="block text-sm font-medium mb-1">Profile Type</label>
        <select
          value={p.type || "rect"}
          onChange={(e) => patchProfile("type", e.target.value)}
          className="w-full px-3 py-2 border rounded"
        >
          <option value="rect">rect</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Width</label>
        <input
          type="number"
          value={params.width ?? 600}
          onChange={(e) => patchParam("width", e.target.value)}
          className="w-full px-3 py-2 border rounded"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Height</label>
        <input
          type="number"
          value={params.height ?? 720}
          onChange={(e) => patchParam("height", e.target.value)}
          className="w-full px-3 py-2 border rounded"
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-1">Thickness</label>
        <input
          type="number"
          value={params.thickness ?? 18}
          onChange={(e) => patchParam("thickness", e.target.value)}
          className="w-full px-3 py-2 border rounded"
        />
      </div>

      <div className="border-t pt-3 space-y-3">
        <div className="text-sm font-semibold">Profile expressions</div>

        <div>
          <label className="block text-sm font-medium mb-1">Width expression</label>
          <input
            value={p.width_expr ?? "width"}
            onChange={(e) => patchProfile("width_expr", e.target.value)}
            className="w-full px-3 py-2 border rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Height expression</label>
          <input
            value={p.height_expr ?? "height"}
            onChange={(e) => patchProfile("height_expr", e.target.value)}
            className="w-full px-3 py-2 border rounded"
          />
        </div>
      </div>
    </div>
  );
}